import React from 'react';
import { Typography, styled } from '@mui/material';

const Chip = styled('div')(({ theme }) => ({
  padding: '3px 10px',
  borderRadius: 999,
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.secondary,
  '&.active': {
    backgroundColor: '#e8f5ec',
    color: '#1e6b35',
  },
}));

type StatusChipProps = {
  active: boolean;
  label: string;
};

const StatusChip: React.FC<StatusChipProps> = ({ active, label }) => (
  <Chip className={active ? 'active' : undefined}>
    <Typography variant="body2" fontWeight={600} color="inherit">
      {label}
    </Typography>
  </Chip>
);

export default StatusChip;
